import { useEffect, type ReactNode } from 'react'
import {
  LEGACY_THREAD_KEY,
  LupeThreadContext,
  useLupeThreadState,
} from '@/hooks/useLupeThread'

/** Holds the Lupe conversation for the signed-in shell, so leaving the Lupe page keeps it alive. */
export function LupeThreadProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    try {
      sessionStorage.removeItem(LEGACY_THREAD_KEY)
    } catch {
      // Storage blocked: nothing was saved there either.
    }
  }, [])

  return (
    <LupeThreadContext.Provider value={useLupeThreadState()}>
      {children}
    </LupeThreadContext.Provider>
  )
}
